import { Col, DatePicker, Form, Input, Row, Select, Card } from "antd";
import {
  eduOptions,
  healthOptions,
  materialStatusOptions,
  professionOptions,
  swidaVillagesFull,
} from "pages/Family/components/constants/constants";
import {
  UserOutlined,
  HeartOutlined,
  PhoneOutlined,
  HomeOutlined,
  DollarOutlined,
} from "@ant-design/icons";
import React from "react";
import { getCountries } from "./helper";

const MotherForm = () => {
  return (
    <div className="space-y-6">
      {/* 👩 Personal Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-pink-600">
            <UserOutlined /> المعلومات الشخصية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          {/* <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["father", "familyBookNumber"]}
              label="رقم دفتر العائلة"
            >
              <Input
                type="number"
                inputMode="numeric"
                placeholder="أدخل رقم دفتر العائلة"
                style={{ maxWidth: "100%" }}
              />
            </Form.Item>
          </Col> */}

          <Col xs={24} sm={8}>
            <Form.Item name={["mother", "firstName"]} label="الاسم">
              <Input placeholder="أدخل الاسم" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name={["mother", "middleName"]} label="اسم الأب">
              <Input placeholder="أدخل اسم الأب" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={8}>
            <Form.Item name={["mother", "lastName"]} label="الكنية">
              <Input placeholder="أدخل الكنية" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "nationalId"]} label="الرقم الوطني">
              <Input type="number" placeholder="أدخل الرقم الوطني" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "birthdate"]} label="تاريخ الميلاد">
              <DatePicker format="DD-MM-YYYY" className="w-full" />
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "nationality"]} label="الجنسية">
              <Select
                showSearch
                style={{ width: "100%" }}
                optionFilterProp="label"
                filterOption={(input, option) => {
                  const label =
                    typeof option?.label === "string" ? option.label : "";
                  console.log(label);
                  return label.toLowerCase().includes(input.toLowerCase());
                }}
              >
                {getCountries().map((country: any) => (
                  <Select.Option
                    key={country.iso3}
                    value={country.nationality}
                    label={country.nationality}
                  >
                    <span
                      style={{
                        marginRight: 8,
                        backgroundImage: `url(https://flagcdn.com/16x12/${country.iso2.toLowerCase()}.png)`,
                        backgroundSize: "cover",
                        display: "inline-block",
                        width: 16,
                        height: 12,
                      }}
                    />
                    {" " + country.nationality + "ة"}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>
          </Col>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "education"]} label="التحصيل العلمي">
              <Select
                allowClear
                showSearch
                placeholder="اختر التحصيل العلمي"
                options={eduOptions}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "professional"]} label="المهنة">
              <Select
                allowClear
                showSearch
                placeholder="اختر المهنة"
                options={professionOptions}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "jobTitle"]} label="المسمى الوظيفي">
              <Input placeholder="أدخل المسمى الوظيفي" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "workplace"]} label="مكان العمل">
              <Input placeholder="أدخل مكان العمل" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* 🏡 Social & Residence Info */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-pink-600">
            <HomeOutlined /> الحالة الاجتماعية والسكن
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["mother", "materialStatus"]}
              label="الحالة الاجتماعية"
            >
              <Select
                allowClear
                showSearch
                placeholder="اختر الحالة الاجتماعية"
                options={materialStatusOptions}
              />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "village"]} label="القرية">
              <Select
                allowClear
                showSearch
                placeholder="اختر القرية"
                options={swidaVillagesFull}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* 💰 Financial Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-pink-600">
            <DollarOutlined /> المعلومات المالية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "salary"]} label="الراتب">
              <Input type="number" placeholder="أدخل الراتب" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "income"]} label="الدخل السنوي">
              <Input type="number" placeholder="أدخل الدخل السنوي" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item
              name={["mother", "expectedFamilyExpenses"]}
              label="نفقات الأسرة"
            >
              <Input type="number" placeholder="أدخل نفقات الأسرة" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* ☎️ Contact Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-pink-600">
            <PhoneOutlined /> معلومات الاتصال
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "phone"]} label="الموبايل ١">
              <Input type="number" placeholder="أدخل رقم الموبايل الأول" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "mobile2"]} label="الموبايل ٢">
              <Input type="number" placeholder="أدخل رقم الموبايل الثاني" />
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "homePhone"]} label="الهاتف الأرضي">
              <Input type="number" placeholder="أدخل رقم الهاتف الأرضي" />
            </Form.Item>
          </Col>
        </Row>
      </Card>

      {/* ❤️ Health Information */}
      <Card
        title={
          <span className="text-lg font-semibold flex items-center gap-2 text-pink-600">
            <HeartOutlined /> الحالة الصحية
          </span>
        }
        bordered={false}
        className="shadow-sm bg-gray-50"
      >
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12} lg={6}>
            <Form.Item name={["mother", "healthStatus"]} label="الحالة الصحية">
              <Select
                allowClear
                showSearch
                placeholder="اختر الحالة الصحية"
                options={healthOptions}
              />
            </Form.Item>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default MotherForm;
